export const colors = {
  main: "#8CD6FC",
  primary: "#52C1FF",
  gray: "#A7A9B7",
  blue: "#133BB7",
  dark: "#1A2E35",
  white: "#FFFFFF",
};
